module.exports = __webpack_public_path__ + "img/335-97fe71.png";